export default "__VITE_ASSET__8984c200__"